const MARKET_COMMAND_PKG = {
    navTitle: "General Market",
    routerName: "GeneralMarketDocs",
    commandsDescription: "Markets, Yield Curve, ETFs, etc...",

    commandList: [
        {
            title: "Markets",
            routerRef: "markets",
            commandString: "!markets",
            description: "Current Market Levels",
            parameters: ["none"],
            examples: [
                "!markets"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Yield Curve",
            routerRef: "yieldcurve",
            commandString: "!yieldcurve",
            description: "Gives the Yield for some bonds and 30y - x bond for Yield Curve",
            parameters: ["none"],
            examples: [
                "!yieldcurve"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Top 20 Drop in Shorts",
            routerRef: "dropshorts",
            commandString: "!dropshorts <Symbol>",
            description: "Returns the top 20 Drops in Shorts for NYSE or NAS",
            parameters: [
                { name: "Symbol: ", desc: "NYSE or NAS" },
            ],
            examples: [
                "!dropshorts NYSE",
                "!dropshorts NAS"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Top 20 Jump in Shorts",
            routerRef: "jumpshorts",
            commandString: "!jumpshorts <Symbol>",
            description: "Returns the top 20 Drops in Shorts for NYSE or NAS",
            parameters: [
                { name: "Symbol: ", desc: "NYSE or NAS" },
            ],
            examples: [
                "!jumpshorts NYSE",
                "!jumpshorts NAS"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Top 15 Top Stocks in Shorts Interest",
            routerRef: "topshorts",
            commandString: "!topshorts <Symbol>",
            description: "Returns the top 15 Drops in Shorts for NYSE or NAS or AMEX",
            parameters: [
                { name: "Symbol: ", desc: "NYSE or NAS or AMEX" },
            ],
            examples: [
                "!topshorts AMEX",
                "!topshorts NYSE",
                "!topshorts NAS"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "ETF Exposure",
            routerRef: "whatetf",
            commandString: "!whatetf <Symbol>",
            description: "Returns the top 5 ETF's by exposure and Share Count for a stock",
            parameters: [
                { name: "Symbol: ", desc: "Stock Symbol you want the ETF of" },
            ],
            examples: [
                "!whatetf AMD",
                "!whatetf GOOG"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "ETF Holdings",
            routerRef: "etf",
            commandString: "!etf <Symbol>",
            description: "Get top holdings of etf",
            parameters: [
                { name: "Symbol: ", desc: "ETF symbol" },
            ],
            examples: [
                "!etf SPY",
                "!etf QQQ"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "ETF Flow In",
            routerRef: "etfflowin",
            commandString: "!etfflowin",
            description: "ETF Flow IN for the week - delayed a few days",
            parameters: ["none"],
            examples: [
                "!etfflowin"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "ETF Flow Out",
            routerRef: "etfflowout",
            commandString: "!etfflowout",
            description: "ETF Flow out for the week - Delayed a few days",
            parameters: ["none"],
            examples: [
                "!etfflowout"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Upcoming FDA Filings",
            routerRef: "fda",
            commandString: "!fda",
            description: "10 Upcoming FDA filings",
            parameters: ["none"],
            examples: [
                "!fda"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "FED Rate Chances",
            routerRef: "fedrates",
            commandString: "!fedrates",
            description: "FED Rate Chances",
            parameters: ["none"],
            examples: [
                "!fedrates"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Fear & Greed Index",
            routerRef: "fgindex",
            commandString: "!fgindex",
            description: "Fear & Greed Index - Investor Sentiment – CNNMoney",
            parameters: ["none"],
            examples: [
                "!fgindex",
                "!fg"
            ],
            type: "General Market", 
            shortcuts: ["fg"]
        },
        {
            title: "US GDP Growth",
            routerRef: "gdpgrowth",
            commandString: "!gdpgrowth",
            description: "US GDP Growth last 10 qtrs",
            parameters: ["none"],
            examples: [
                "!gdpgrowth"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Holiday Calendar",
            routerRef: "holiday",
            commandString: "!holiday",
            description: "Holiday Calendar for US Stock Market",
            parameters: ["none"],
            examples: [
                "!holiday"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "IPO Calendar",
            routerRef: "ipolist",
            commandString: "!ipolist",
            description: "IPO's for the Month",
            parameters: ["none"],
            examples: [
                "!ipolist"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Institutional Holdings",
            routerRef: "instholdings",
            commandString: "!etf <Symbol>",
            description: "Top 10 institutional holdings of stock",
            parameters: [
                { name: "Symbol: ", desc: "Stock Symbol to see Inst. Holdings" },
            ],
            examples: [
                "!instholdings AMD",
                "!instholdings TWTR"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Daily Economic Calendar",
            routerRef: "calendar",
            commandString: "!calendar",
            description: "Returns the days economic calendar events",
            parameters: ["none"],
            examples: [
                "!calendar"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "President's Schedule",
            routerRef: "president",
            commandString: "!president",
            description: "President's Daily Schedule",
            parameters: ["none"],
            examples: [
                "!president"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Lockup Expirations",
            routerRef: "lockup",
            commandString: "!lockup",
            description: "When lockups expire - list",
            parameters: ["none"],
            examples: [
                "!lockup"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Analyst Ratings",
            routerRef: "ratings",
            commandString: "!ratings <Type>",
            description: "Analyst Ratings for the day",
            parameters: [
                { name: "Type: ", desc: "Values can be - upgrades,downgrades, or coverage" },
            ],
            examples: [
                "!ratings upgrades",
                "!ratings downgrades"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Top News - CNBC",
            routerRef: "topnews",
            commandString: "!topnews",
            description: "Top headlines from CNBC",
            parameters: ["none"],
            examples: [
                "!topnews"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Top News - CNBC",
            routerRef: "topnews",
            commandString: "!topnews",
            description: "Top headlines from CNBC",
            parameters: ["none"],
            examples: [
                "!topnews"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Dividen List - Daily",
            routerRef: "dividends",
            commandString: "!dividends",
            description: "Stocks paying Dividends that day",
            parameters: ["none"],
            examples: [
                "!dividends"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Splits",
            routerRef: "splits",
            commandString: "!splits",
            description: "List of upcoming splits per Nasdaq",
            parameters: ["none"],
            examples: [
                "!splits"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
       // {
       //     title: "RobinHood Popular",
       //     routerRef: "rhpop",
       //     commandString: "!rhpop",
       //     description: "Most popular holdings on RobinHood - Updates Hourly",
      //      parameters: ["none"],
       //     examples: [
       //         "!rhpop"
       //     ],
       //     type: "General Market",
       //     shortcuts: ["none"]
       // },
       // {
       //     title: "RobinHood Change",
       //     routerRef: "rhchange",
       //     commandString: "!rhchange <Time>",
       //     description: "See OI and call/put ratio for given stock",
        //    parameters: [
        //        { name: "Time", desc: "The timeframe you want - can be 1d, 3d, 1w - default is 1d - Updates Hourly" },
        //    ],
        //    examples: [
        //        "!rhchange 1d",
        //        "!rhchange 1w"
        //    ],
        //    type: "General Market",
        //    shortcuts: ["none"]
        //},
        {
            title: "Popular Tickers - Last Hour",
            routerRef: "pop1h",
            commandString: "!pop1h",
            description: "Returns the most popular tickers over the last hour",
            parameters: ["none"],
            examples: [
                "!pop1h"
            ],
            type: "General Market",
            shortcuts: ["none"]
        },
        {
            title: "Popular Tickers - Day",
            routerRef: "pop1d",
            commandString: "!pop1d",
            description: "Returns the most popular tickers over for the day",
            parameters: ["none"],
            examples: [
                "!pop1d"
            ],
            type: "General Market",
            shortcuts: ["none"]
        },
        {
            title: "Short Sale Restrictions",
            routerRef: "dividends",
            commandString: "!dividends",
            description: "Returns the companies on the Short Sale Circuit Breaker",
            parameters: ["none"],
            examples: [
                "!dividends"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
        {
            title: "Spy Weight",
            routerRef: "spyweight",
            commandString: "!spyweight",
            description: "S&P Sector Weights",
            parameters: ["none"],
            examples: [
                "!spyweight"
            ],
            type: "General Market", 
            shortcuts: ["none"]
        },
    ]
}



export {MARKET_COMMAND_PKG};